import logo from './logo.svg';
import './App.css';
import Header from './Components/Shared/Header/Header';
import Home from './Pages/Home';
import {Switch,Route, Redirect} from 'react-router-dom';
import EBooks from './Pages/EBooks';
import LogIn from './Pages/LogIn';
import Pricing from './Pages/Pricing';
import 'aos/dist/aos.css';
import AOS from 'aos';
import Signup from './Pages/Signup';
import React,{useEffect} from 'react';
import Blogs from './Pages/Blogs';
import Author from './Pages/Author';
import BlogDetails from './Pages/BlogDetails';
import ContactUs from './Pages/ContactUs';
import ScrollToTop from './ScrollToTop';
import Terms from './Pages/Terms';
import Collaboration from './Pages/Collaboration';
import AboutUs from './Pages/AboutUs';
import Jobs from './Pages/Jobs';
import Privacy from './Pages/Privacy';
import Status from './Pages/Status';
import MobileApp from './Pages/MobileApp';
import ResourcesHub from './Pages/ResourcesHub';
import HelpCenter from './Pages/HelpCenter';
import Customer from './Pages/Customer';
import Monzo from './Pages/Monzo';
import Bits from './Pages/Bits';
import Desktop from './Pages/Desktop';
import Ipad from './Pages/Ipad';
import Mac from './Pages/Mac';
import Why from './Pages/Why';
import What from './Pages/What';
import Prototyping from './Pages/Prototyping';
import Front from './Pages/Front';
import Enterprise from './Pages/Enterprise';
import Wireframe from './Pages/Wireframe';
import HelpDetails from './Pages/HelpDetails';
import Android from './Pages/Android';
import AndroidPad from './Pages/AndroidPad';
import Developer from './Pages/Developer';
import Prototype from './Pages/Prototype';
function App() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      disable: 'mobile',
      once: true,
    });
  }, []);
  return (
    <div className="App">
      <ScrollToTop />
     <Switch>
    <Route exact path="/">
    <Home />
    </Route>
    <Route exact path="/ebooks">
    <EBooks/>
    </Route>
    <Route exact path="/login">
    <LogIn />
    </Route>
    <Route exact path="/pricing">
    <Pricing/>
    </Route>
    <Route exact path="/sign-up">
    <Signup/>
    </Route>
    <Route exact path="/Blog">
    <Blogs/>
    </Route>
    <Route exact path="/liz-steelman">
    <Author/>
    </Route>
    <Route exact path="/who-are-beguiled-demoralized-by-charms-of-moment">
    <BlogDetails/>
    </Route>
    <Route exact path="/contact-us">
    <ContactUs/>
    </Route>
    <Route exact path="/terms-of-service">
    <Terms/>
    </Route>
    <Route exact path="/collaboration">
    <Collaboration/>
    </Route>
    <Route exact path="/about-us">
    <AboutUs/>
    </Route>
    <Route exact path="/jobs">
    <Jobs/>
    </Route>
    <Route exact path="/privacy">
    <Privacy/>
    </Route>
    <Route exact path="/status">
    <Status/>
    </Route>
    <Route exact path="/mobile-app">
    <MobileApp/>
    </Route>
    <Route exact path="/resources-hub">
    <ResourcesHub/>
    </Route>
    <Route exact path="/help-center">
    <HelpCenter/>
    </Route>
    <Route exact path="/customer-stories">
    <Customer/>
    </Route>
    <Route exact path="/monzo-increased-productivity">
    <Monzo/>
    </Route>
    <Route exact path="/bits-bobs-details">
    <Bits/>
    </Route>
    <Route exact path="/desktop">
    <Desktop/>
    </Route>
    <Route exact path="/ipad-app">
    <Ipad/>
    </Route>
    <Route exact path="/imac-app">
    <Mac/>
    </Route>
    <Route exact path="/why">
    <Why/>
    </Route>
    <Route exact path="/what-on-details">
    <What/>
    </Route>
    <Route exact path="/prototype">
    <Prototyping/>
    </Route>
    <Route exact path="/front-end-developer">
    <Front/>
    </Route>
    <Route exact path="/enterprise">
    <Enterprise/>
    </Route>
    <Route exact path="/wireframe">

    <Wireframe/>
    </Route>
    <Route exact path="/help-center-details">
    <HelpDetails/>
    </Route>
    <Route exact path="/android-phone">
    <Android/>
    </Route>
    <Route exact path="/android-pad">
    <AndroidPad/>
    </Route>
    <Route exact path="/developer-api">
    <Developer/>
    </Route>
    <Route exact path="/prototyping">
    <Prototype/>
    </Route>
    <Redirect to="/" />
    </Switch>
    </div>
  );
}

export default App;

